// Module
var code = "<div class=\"question-element\"> <div class=\"question content-element-layout\"> <div class=\"content-element -h3\"> <h2 class=\"text-style -h3\">[[ quiz.result.title ]]</h2> </div> <div class=\"content-element\"> <div class=\"text-style -para\" view=\"html\" data=\"[[ quiz.result.text ]]\"></div> </div> </div> </div> ";
// Exports
export default code;